import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';
import {LargeBusiness} from "../../Constants"
class SocialLinks extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isBusinessSite: location.href.indexOf("/business/") > 0,
      isLBSite: LargeBusiness.isLBSite
    };
  }
  render() {
    return (
      <Container>


        <Row className="social-links">
          <Col className="col-md-12 social-top">
            <ul className="list-inline text-center">

              {this.props.navItems.map((navItem, index) => {
                return (
                  <li className="list-inline-item" key={'list-inline-item' + index}>
                    <a  aria-label={navItem.link.ariaLabel || undefined } 
                    // title={navItem.link.title} 
                    target={navItem.link.target} href={navItem.link.link} 
                    rel={navItem.link.target === '_blank' ? 'noopener noreferrer' : undefined}  
                    className={!(this.state.isBusinessSite || this.state.isLBSite) ? 
                      ('eir-icon icon-' + navItem.icon + '--black') : 
                      'eir-icon ' + navItem.icon}
                    >
                      <div
                        className={
                          !(this.state.isBusinessSite || this.state.isLBSite)
                            ? "eir-icon icon-" + navItem.icon + "--black"
                            : "eir-icon " + navItem.icon
                        }
                        // role="img"
                        // alt={navItem.link.text}
                      />
                    </a>
                  </li>
                );
              })}

            </ul>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default SocialLinks;
